// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"195":"16d99faf","594":"8422ae60"}[chunkId] + ".css";
};